import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=3b641582&scoped=true&lang=pug&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "@components/Menu/Menu.styl?vue&type=style&index=0&id=3b641582&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b641582",
  null
  
)

export default component.exports